<template>
  <div class="progress-bar">
    <div
      ref="progress"
      class="progress"
    ></div>
  </div>
</template>

<script>
import windowUtil from '@/utils/window'

export default {
  name: 'ProgressBar',
  mounted () {
    windowUtil.addScrollListener(this.onScroll)
  },
  methods: {
    onScroll () {
      this.$refs.progress.style.transform = `translateX(${windowUtil.scrollPosition}%)`
    }
  }
}
</script>

<style lang="scss" scoped>
.progress-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  z-index: 100;
}
.progress {
  position: absolute;
  top: 0;
  bottom: 0;
  left: -100%;
  width: 100%;
  background-color: $c-red;
  will-change: width;
}
</style>
